<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Nhập điểm" :link="[{ text: 'Nhập điểm', href: '/marks-input' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <InputMarkFilter @onFilterChanged="refresh" />
    </v-card>
    <ClassInputMarkDataTable class="mx-4" v-show="filterParam.class" ref="table" />
    <MarkBlankView class="mx-4" v-if="!filterParam.class" :markView="false" />

    <MarkInputExcelDialog :state="showExcelDialog" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import InputMarkFilter from '@/modules/mark/InputMarkFilter.vue'
import MarkBlankView from '@/modules/mark/MarkBlankView.vue'
import { mapState } from 'vuex'
import ClassInputMarkDataTable from '@/modules/mark/ClassInputMarkDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    InputMarkFilter,
    MarkBlankView,
    ClassInputMarkDataTable,
    MarkInputExcelDialog: () => import('@/modules/mark/MarkInputExcelDialog.vue')
  },
  data() {
    return {
      showExcelDialog: false
    }
  },
  watch: {},
  computed: {
    ...mapState('ClassMarkInput', ['filterParam'])
  },
  methods: {
    async refresh(query) {
      await this.$refs.table.refresh(query)
    }
  }
}
</script>

<style lang="scss" scoped></style>
